<template>
    <v-container fluid>
      <v-row no-gutters class="mt-5">
        <v-col cols="8">
          <v-card class="pa-5" v-if="tool">
            <v-card-title>
              <h1>{{ tool.name }}</h1>
            </v-card-title>
  
            <v-card-text>
              <table class="tool-details-table">
                <tbody>
                  <tr>
                    <td><strong>Category</strong></td>
                    <td>{{ tool.category }}</td>
                  </tr>
                  <tr>
                    <td><strong>Auth</strong></td>
                    <td>
                      {{ tool.auth }} <br />
                      <a :href="`mailto:${tool.email}`">{{ tool.email }}</a>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Content</strong></td>
                    <td>{{ tool.content }}</td>
                  </tr>
                </tbody>
              </table>
            </v-card-text>
          </v-card>
          <div v-else>
            Loading tool details...
          </div>
        </v-col>
  
        <v-col cols="4">
          <v-card class="pa-3">
            <v-card-title>Additional Information</v-card-title>
            <v-card-subtitle>Related Images or Tools</v-card-subtitle>
            <v-card-text>
              <v-img
                src="https://via.placeholder.com/300x200"
                alt="Placeholder Image"
                class="mb-3"
              ></v-img>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    props: ['id'], // 接收路由傳遞的 id
    data() {
      return {
        tools: [
          { id: 1, name: 'ToolNameHere 1', category: 'AI', auth: '1234567890', email: 'example1@example.com', content: '這是第一個工具的詳細內容。' },
          { id: 2, name: 'ToolNameHere 2', category: 'App', auth: '9876543210', email: 'example2@example.com', content: '這是第二個工具的詳細內容。' },
          { id: 3, name: 'ToolNameHere 3', category: 'Framework', auth: '2468135790', email: 'example3@example.com', content: '這是第三個工具的詳細內容。' },
        ],
        tool: null // 用來儲存找到的工具詳細資訊
      };
    },
    mounted() {
      // 根據路由傳遞的 id 找到對應的工具
      this.tool = this.tools.find(tool => tool.id === parseInt(this.id));
  
      if (!this.tool) {
        console.error('Tool not found with id:', this.id);
      }
    }
  };
  </script>
  